<template>
  <div class="home-wrap">
    <div class="colhead">
      <div class="title">商户信息管理系统</div>
      <!-- <svg-icon icon-class="mark" style="margin-left:10px; "></svg-icon> -->
      <div class="retreat" @click="retreat">退出登录</div>
    </div>

    <!-- —————————————————————— -->
    <div class="search-wrap">
      <el-form>
        <el-row :gutter="20">
          <el-col :span="spanCol1">
            <el-form-item label="是否签订责任书：" label-width="125px">
              <el-select v-model="book" placeholder="请选择">
                <el-option label="是" value="1" />
                <el-option label="否" value="0" />
                <el-option label="全部" value="" />

              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="spanCol1">
            <el-form-item label="所属街道：" label-width="85px">
              <el-select
                v-model="street"
                placeholder="请选择"
                @change="streetChange"
              >
                <el-option
                  v-for="item in allStreets"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="spanCol1">
            <el-form-item label="所属社区：" label-width="85px">
              <el-select v-model="sequ" placeholder="请选择">
                <el-option
                  v-for="item in chooseCommunity"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="spanCol1">
            <el-form-item label="所属网格：" label-width="85px">
              <el-input v-model="grid"  disabled />
            </el-form-item>
          </el-col>

          <el-col :span="spanCol2">
            <el-form-item>
              <el-row type="flex">
                <el-col :span="14">
                  <el-input
                    v-model="inquire"
                    placeholder="统一社会信用代码/名称/地址/备注信息/二维码编号"
                  />
                </el-col>

                <el-col :span="10">
                  <button @click="handleSearch" class="inquire">查询</button>
                  <button @click="resetOpts" class="inquire btn-reset">
                    重 置
                  </button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 把整体看作一个table -->

    <!-- 头部区域 -->

    <el-main class="main">
      <el-button
        type="primary"
        @click="add"
        class="baonewAdd"
        style="margin-left: 12px"
        >添加</el-button
      >
      <el-button
        type="primary"
        :disabled="isDisabledExport"
        @click="derive"
        class="baonewAdd1"
        style="margin-left: 12px"
        >导出</el-button
      >
    </el-main>
    <!-- 头部区域 -->

    <div class="home-table">
      <el-table
        border
      
        :header-cell-style="{ background: '#e6e6e6', color: '#333333' }"
        @selection-change="handleSelectionChange"
        highlight-current-row
        stripe
        :data="tableData"
      >
        <el-table-column type="selection" width="55"> </el-table-column>

        <el-table-column fixed="left" label="操作" width="140">
          <template slot-scope="scope">
            <el-button @click="deletevalue(scope.row)" type="text" size="small"
              >删除</el-button
            >

            <!-- 头部区域  @click="handleDelete(scope.$index, scope.row)"-->

            <el-button @click="userchunge(scope.row)" type="text" size="small"
              >修改</el-button
            >

            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >查看</el-button
            >
          </template>
        </el-table-column>

        <el-table-column
          fixed="left"
          prop="enterpriseName"
          label="企业名称"
          width="150"
        >
        </el-table-column>
        <el-table-column prop="qrNumber" label="二维码编号" width="130">
        </el-table-column>

        <!--————————————————————————————————————————————————————-->

        <!--————————————————————————————————————————————————————-->

        <el-table-column label="二维码" width="120">
          <template slot-scope="scope">
            <a style="color: #409eff" :href="scope.row.qrUrl" target="_blank"
              >查看</a
            >
          </template>
        </el-table-column>

        <!--————————————————————————————————————————————————————-->
        <el-table-column label="是否签订责任书" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.responsibilityFlag == 0">否</span>
            <span v-else>是</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="socialCreditNumber"
          label="统一社会信用代码"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="businessScope" label="经营范围" width="300">
        </el-table-column>
        <el-table-column prop="address" label="地址" width="120">
        </el-table-column>
        <el-table-column prop="belongStreet" label="所属街道" width="120">
        </el-table-column>
        <el-table-column prop="belongCommunity" label="所属社区" width="120">
        </el-table-column>
        <el-table-column prop="belongGrid" label="所属网格" width="120">
        </el-table-column>
        <el-table-column prop="owner" label="责任人" header="30px" width="120">
        </el-table-column>
        <el-table-column
          prop="ownerIdentityNumber"
          label="责任人身份证号"
          width="170"
        >
        </el-table-column>

        <el-table-column prop="ownerPhone" label="责任人联系电话" width="120">
        </el-table-column>

        <el-table-column
          prop="legalRepresentativePhone"
          label="法定代表人电话"
          width="120"
        >
        </el-table-column>

        <el-table-column prop="remark" label="备注信息" width="500px">
        </el-table-column>
      </el-table>
    </div>

    <div class="pag">
      <div class="pag-ctx">
        <span>当前 {{ curPage }} 页, {{ tableData.length }} 条</span>
      </div>

      <el-pagination
      background
        @current-change="handleCurrentChange"
        :current-page.sync="curPage"
        :page-size="pageSize"
        layout=" prev, pager, next, jumper"
        :total="total"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { community, allStreets, getOrDestroy } from "../utils";
// import emitter from "../utils/emitter";
import QRCode from "qrcodejs2";
export default {
  name: "home",
  data() {
    return {
      total: 0,
      pageSize: 20,
      curPage: 1,
      tableData: [],
      isDisabledExport: true,
      once: true, // 接口只执行一次的开关
      book: undefined, // 责任书
      sequ: undefined, // 所属社区
      inquire: undefined, // 模糊查询(地址、社会信用代码等)
      street: undefined, // 所属街道
      grid: undefined, // 所属网格
      allData: [], // 所有数据
      spanCol1: 4,
      spanCol2: 8,
      allStreets: allStreets(),
      community: community(),
      oncederive:""
    };
  },
  created() {
 
    this.handleCurrentChange();
  },
  computed: {
    chooseCommunity() {
      return this.community[this.street] || [];
    },
  },
  methods: {
    streetChange() {
      this.sequ = undefined;
    },
    //小框框 _________________

    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },

    // 修改页面
    userchunge(row) {
      this.$router.push({
        name: "add",
        query: { row },
      });
    },

    //_________________________________
    // 进入查看页面
    handleClick(row) {
      console.log(row);
      this.$router.push({
        name: "informationview",
        query: {
          viewPage: row,
        },
      });
    },
    // 删除商户信息handleDelete(scope.$index, scope.row)"
    deletevalue(row) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "info",
      }).then(() => {
        axios
          .delete(`/api/admin/merchantInfo/delMerchantInfoById/${row.id}`)
          .then((res) => {
            const { success } = res.data;
            if (success) {
              this.$message({ type: "info", message: "删除成功!" });
              this.handleCurrentChange();
            } else {
              throw "删除失败!";
            }
          })
          .catch((e) => {
            this.$alert(e || "删除失败!", "提 示");
            console.warn(e);
          });
      });
    },

    // 分页器请求
    handleCurrentChange() {
      const url = "/api/admin/merchantInfo/getMerchantList";
      axios
        .post(url, {
          page: this.curPage,
          size: this.pageSize,
          belongStreet: this.street,
          belongCommunity: this.sequ,
          responsibilityFlag: this.book,
          merchantInfo: this.inquire,
        })
        .then((res) => {
          const { success, data, message } = res.data;
          if (success) {
            this.total = data.merchantList.total;
            this.tableData = data.merchantList.list;

            if (this.once) {
              this.getAllTableData(this.total);
              this.once = false;
            }
          } else {
            throw message || "获取数据失败";
          }
        })
        .catch((err) => {
          this.$alert(err || "获取数据失败", "提示", { type: "warning" });
        });
    },

    // 获取所有的数据
    getAllTableData(num) {
      const url = "/api/admin/merchantInfo/getMerchantList";
      axios
        .post(url, {
          page: 1,
          size: num,
        })
        .then((res) => {
          const { success, data, message } = res.data;
          if (success) {
            this.allData = data.merchantList.list;
            this.isDisabledExport = false;
          }
        });
    },
    resetOpts() {
      this.book = undefined;
      this.street = undefined;
      this.sequ = undefined;
      this.inquire = undefined;
    },
    handleSearch() {
      this.handleCurrentChange();
    },
    // 添加————————————————————————
    add() {
      this.$router.push({
        name: "add",
      });
    },
    // ——————————————————————————
    handleSelectionChange(val) {
      console.log(val);
      this.oncederive=val
      console.log(this.oncederive)





    
    },

    // —导出—————————————————————————————————
    derive() {
      const derive_url = "/api/admin/excelOperation/exportExcel"; //上线代码

      // _____________________________
      axios({
        method: "post",
        url: derive_url,
        responseType: "blob",
        data: {
        busClickDto:this.oncederive,
        // busClickDto:  this.allData,

        },
      }).then((response) => {
        let fileName = window.decodeURI(
          response.headers["content-disposition"].split("=")[1]
        );
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(
          new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          })
        );
        link.target = "_blank";
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    //  退出登录——————————————————————————
    retreat() {
      const url_quit = "/api/admin/userInfo/cancle";
      axios
        .get(url_quit, {})
        .then((res) => {
          const { success } = res.data;
          if (success) {
            getOrDestroy("loginStatus", 0);
            this.$router.push({
              name: "login",
            });
          } else {
            throw "退出失败!";
          }
        })
        .catch((e) => {
          this.$alert("退出失败!", "提示", { type: "warning" });
        });
    },
   
  },
};
</script>
<style scoped>
:focus {
  outline: 0;
}
.home-table {
  min-height: calc(100vh - 286px);
  background-color: #fff;
    margin-left:24px;
  margin-right:24px;

}

.home-table /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 12px !important;
  height: 12px !important;
}

.home-table /deep/ .el-table__fixed::before {
  background-color: transparent;
}

.colhead {
  background-color: #1f2942;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 0 24px;
}

.title {
  font-family: MicrosoftYaHei;
  font-size: 24px;
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0);
}

.retreat {
  font-family: MicrosoftYaHei;
  font-size: 20px;
  color: white;
  cursor: pointer;
}

.inquire {
  width: 81px;
  height: 36px;
  background-color: #1f6acb;
  border-radius: 4px;
  border: none;
  font-family: MicrosoftYaHei;
  font-size: 12px;
  color: #ffffff;
  margin-left: 10px;
}

.btn-reset {
  border: 1px solid #1f6acb;
  color: #333;
  background-color: #fff;
  margin-left: 7px;
}
.main {
  background-color: #fff;
  display: flex;
  margin: auto;
  margin-top: 12px;
     margin-left:24px;
  margin-right:24px;
}
.baonewAdd {
  width: 80px;
  height: 30px;
  background-color: #1f6acb;
  border-radius: 4px;
  border: solid 1px #1f6acb;
  font-family: MicrosoftYaHei;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.baonewAdd1 {
  width: 80px;
  height: 30px;
  border: 1px solid #1f6acb;
  border-radius: 4px;
  border: solid 1px #1f6acb;
  font-family: MicrosoftYaHei;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0);
}
.ta {
  margin: auto;
  background-color: #fff;
}
.pag {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #fff;
     margin-left:24px;
  margin-right:24px;
}
.pag > .pag-ctx {
  color: #666;
  font-size: 12px;
}
.street_choose {
  width: 100%;
  position: fixed;

  left: 0;
  right: 0;
  bottom: 0;

  background: rgba(0, 0, 0, 0.7);

  z-index: 3;
}
.big_title {
  font-size: 30px;
  margin-left: 20px;
  border: #1f2942;

  background-color: pink;
}

.search-wrap {
  background-color: #fff;
  padding: 20px;
  margin-left:24px;
  margin-right:24px;

}
.search-wrap /deep/ .el-form-item {
  padding: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue